import styled, { Scale } from '@secretescapes/falcon';
import { type CommonStyledProps } from '@utils/styles.utils';

export const GalleryOverlay = styled('div')<CommonStyledProps>`
  position: absolute;
  top: 0;
  ${({ isMobile }) => isMobile && 'width: 100%;'};
  box-sizing: border-box;
  padding: ${Scale.m};
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  z-index: 2;
`;

export const StyledDiscountBadge = styled('div')`
  > div {
    margin: unset;
  }
`;
